import React from "react"
import { Button, Text } from "@chakra-ui/react"
import { Icon } from "../"

export default function FormSubmit({ success }) {
  return (
    <React.Fragment>
      <Button
        {...(false === success && { bg: "red.300", pointerEvents: "none" })}
        {...(success && { bg: "green.400", pointerEvents: "none" })}
        mr={{ base: "auto", lg: 0 }}
        layerStyle="prominent"
        variant="primary"
        type="submit"
        ml="auto"
      >
        <Text as="span" lineHeight="1">
          {success ? "Success" : "Submit"}
        </Text>

        {null === success && <Icon name="emailSend" boxSize={5} ml={3} />}
      </Button>
      {false === success && (
        <Text color="danger.a200" mt={3} size="sm" textAlign="right">
          We&lsquo;ve encountered an error.
          <br />
          Please try again later.
        </Text>
      )}
    </React.Fragment>
  )
}
